export default "__VITE_ASSET__D5zzkNl1__"